
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Why am I getting HTML attribute warnings?`}</h2>
    <p>{`The warning message below indicates that non-standard attributes are being attached to
HTML DOM elements such as `}<inlineCode parentName="p">{`<div>`}</inlineCode>{` or `}<inlineCode parentName="p">{`<a>`}</inlineCode>{`. If you are seeing this warning message, it is likely that you or a library you are using is attaching props as attributes to HTML DOM elements.`}</p>
    <pre><code parentName="pre" {...{}}>{`Warning: Received "true" for a non-boolean attribute
`}</code></pre>
    <p>{`If you're seeing this warning you are probably passing `}<inlineCode parentName="p">{`true`}</inlineCode>{` where `}<inlineCode parentName="p">{`"true"`}</inlineCode>{` would be appropriate. It's likely that this comes from a `}<inlineCode parentName="p">{`.attrs`}</inlineCode>{` property, or from a completely unrelated prop that you're passing to a `}<inlineCode parentName="p">{`styled(Component)`}</inlineCode>{` component.`}</p>
    <p>{`To learn more about how props are passed, see `}<a parentName="p" {...{
        "href": "/docs/basics#passed-props",
        "title": "Passing Props to styled-components"
      }}>{`this section`}</a>{`.`}</p>
    <p>{`For example:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Link = props => (
  <a {...props} className={props.className}>
    {props.text}
  </a>
)

const StyledComp = styled(Link)\`
  color: \${props => (props.red ? 'red' : 'blue')};
\`

<StyledComp text="Click" href="https://www.styled-components.com/" red />
`}</code></pre>
    <p>{`This will render:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<a text="Click" href="https://www.styled-components.com/" red="true" class="[generated class]">Click</a>
`}</code></pre>
    <p>{`React will warn on non-standard attributes being attached such as "red" and "text", which are not valid HTML attributes for the `}<inlineCode parentName="p">{`<a>`}</inlineCode>{` element. To fix this, you can use argument destructuring to pull out those known styling props:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`const Link = ({ className, red, text, ...props }) => (
  <a {...props} className={className}>
    {text}
  </a>
)

const StyledComp = styled(Link)\`
  color: \${props => (props.red ? 'red' : 'blue')};
\`

<StyledComp text="Click" href="https://www.styled-components.com/" red />
`}</code></pre>
    <p>{`This will render:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-html"
      }}>{`<a href="https://www.styled-components.com/" class="[generated class]">
  Click
</a>
`}</code></pre>
    <p>{`When you use argument destructuring, any variables pulled out of the props object will not be included when spread-applying the remaining props (`}<inlineCode parentName="p">{`...props`}</inlineCode>{`);`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;